module.exports = new __parcel__URL__("soleil-voile.1eaa033b.svg").toString();